X-Content-Type-Options: nosniff

<template>
  <div class="title" @click="change('')">
    <div class="title_box">
      <div class="title_logo">
        <img class="title_logo_img" src="./../assets/images/logo.png" alt="" srcset="">
      </div>


      <div class="title-left">
        <router-link to="/">
          　　 <span class="">首页</span>
        </router-link>


        <div class="link_box" @click.stop="change('1')">
          <span class="link_box_p" :class="{link_box_cs:currentIndex == 1}">关于我们</span>
          <span class="caret"></span>

          <div class="link_box_bottom" :class="{active:currentIndex == 1}">
            <div @click="toAbout(0)">集团介绍</div>
            <div @click="toAbout(1)">锦欣版图</div>
            <div @click="toAbout(2)">企业荣誉</div>
            <div @click="toAbout(3)">发展历程</div>
            <div @click="toAbout(4)">企业愿景</div>
            <div @click="toAbout(5)">管理团队</div>
          </div>

        </div>




        <div class="link_box" @click.stop="change('2')" :class="{active:currentIndex== 2}">
          　<span class="link_box_p" :class="{link_box_cs:currentIndex == 2}">产业布局</span>
          <span class="caret"></span>

          <div class="link_box_bottom" :class="{active:currentIndex == 2}">
            <div @click="toMedicalReproductive">生殖与医疗</div>
            <!-- <div @click="toWellness">锦欣康养</div> -->
            <div @click="tonewMechanism">新兴机构</div>
          </div>
        </div>



        <router-link to="/Corporate">
          　　<span class="">企业责任</span>
        </router-link>
        <router-link to="/News">
          　　<span class="">新闻资讯</span>
        </router-link>

        <router-link to="/Message">
          　　<span class="">创始人寄语</span>
        </router-link>


        <div class="link_box" @click.stop="change('3')" :class="{active:currentIndex== 3}">
          　<span class="link_box_p" :class="{link_box_cs:currentIndex == 3}"> 锦欣支持</span>
          <span class="caret"></span>

          <div class="link_box_bottom" :class="{active:currentIndex == 3}">
            <div @click="toSupport">国际投资人</div>
          </div>
        </div>
        　




        <router-link to="/channels">
          　　<span class="">人才招募</span>
        </router-link>
      </div>

    </div>


  </div>
</template>


<script>
  // 引用组件
  import Vue from "vue";
  import {
    Toast,
    Col
  } from "vant";
  import $ from "jquery";
  Vue.use(Toast);





  export default {
    data() {
      return {
        currentIndex: ""
      };

    },




    // 屏幕自适应配置
    // mounted() {
    //   //自适应窗口
    //   if (window.screen.width > 1200) {
    //     function bodyScale() {
    //       let deviceWidth = document.documentElement.clientWidth;
    //       let scale = deviceWidth / 1920;
    //       document.body.style.zoom = scale;
    //     }
    //     window.onload = window.onresize = function() {
    //       bodyScale();
    //     }
    //   }
    // },




    methods: {

      // 获取首页数据banner
      getBanner() {
        this.$api.get('ad/list', {}).then(res => {
          if (res.errno == 0) {
            this.banner = res.data.list
          }

        }, error => {
          console.log(error)
          uni.showToast({
            title: "请求失败"
          });
        })
      },

      //跳转
      toSupport() {
        this.$router.push({
          path: '/support',
        })
      },

      //跳转
      tonewMechanism() {
        this.$router.push({
          path: '/newMechanism',
        })
      },

      //跳转
      toWellness() {
        this.$router.push({
          path: '/wellness',
        })
      },

      // 跳转
      toMedicalReproductive() {
        this.$router.push({
          path: '/MedicalReproductive',
        })
      },

      // 关于我们
      toAbout(e) {
        console.log('--------------跳转')
        this.$router.push({
          path: '/about'
        })
        localStorage.setItem("aboutid", e);
        
      },



      // 切换按钮
      change(e) {
        console.log(e, '---------------1')
        this.currentIndex = e
      }





    }
  }
</script>





<style >
  .title {
    height: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .title_box {
    width: 95%;
    height: auto;
    margin: 0 auto;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

  }


  .title_logo {
    width: 215px;
    height: 26px;
    margin-left: 15px;
  }

  .title_logo_img {
    width: 215px;
    height: 26px;
  }



  .title-left {
    width: 76%;
    height: auto;
    margin-left: 0;
    display: flex;

  }


  span {
    font-size: 16px
  }

  a {
    width: 12%;
    height: 48px;
    color: black;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-decoration: none;
    line-height: 48px;
    text-align: center
  }

  a span:hover {
    padding-bottom: 10px;
    background: none;
    border-bottom: 2px solid #fff
  }



  .link_box {
    width: 12%;
    height: 48px;
    color: black;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-decoration: none;
    line-height: 48px;
    text-align: center;
    position: relative;
  }



  .link_box_p:hover {
    cursor: pointer;
    padding-bottom: 10px;
    background: none;
    border-bottom: 2px solid #fff
  }


  .link_box_bottom {
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 10000;
    background-color: rgba(255, 255, 255, 0.7);
    display: none;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }


  .link_box_bottom div {
    padding: 3px 20px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
    line-height: 28px;
    color: #5C5C5C;
    font-size: 14px;
    cursor: pointer;
    text-align: left;
  }

  .link_box_bottom div:hover {
    color: #BF292C
  }


  .active {
    display: block;
  }


  .link_box_cs {
    padding-bottom: 10px;
    border-bottom: 2px solid #fff
  }



  .caret {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 2px;
    vertical-align: middle;
    border-top: 4px dashed;
    border-top: 4px solid\9;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
  }





  .serch {
    height: 32px;
    width: 500px;
    background-color: #fff;
    margin: auto;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/CrmHeader.vue